export class DragHelper {
    // Calculates the new position of an element based off of the drag distance of the cursor

    private initialCursor: [number, number] = [0, 0];

    private pannableElementPosition: [number, number] = [0, 0];

    private pannableRange: [number, number];

    private dragging: boolean;

    constructor(initialCursor: [number, number]) {
        this.setInitialCursor(initialCursor);
    }

    draggingBegan(pannableRange: [number, number]) {
        this.pannableRange = pannableRange;
        this.dragging = true;
    }

    setInitialCursor(initialCursor: [number, number]) {
        this.initialCursor = initialCursor;
    }

    getDifference(currentCursor: [number, number]): [number, number] {
        const xDifference = this.pannableElementPosition[0] + currentCursor[0] - this.initialCursor[0];
        const yDifference = this.pannableElementPosition[1] + currentCursor[1] - this.initialCursor[1];
        return [getTransformationClamped(xDifference, this.pannableRange[0]), getTransformationClamped(yDifference, this.pannableRange[1])];
    }

    draggingEnded(elementTranslation: [number, number]) {
        this.dragging = false;
        this.pannableElementPosition = elementTranslation;
    }

    isDragging() {
        return this.dragging;
    }
}

/**
 * Gets a transformation limited by a provided range
 * @param draggedDistance The distance the pannable content was dragged
 * @param range The available range for dragging
 * @returns The transformation limited by the provided range
 */
function getTransformationClamped(draggedDistance: number, range: number) {
    // Prevent scrolling outside the available bounds
    // This function is quite unreadable. In the future we should replace with a proper zoom/ pan library.

    const reversedXDifference = -draggedDistance;

    let xFinal: number;

    if (reversedXDifference < 0) {
        xFinal = 0;
    }

    if (reversedXDifference > range) {
        // eslint-disable-next-line prefer-destructuring
        xFinal = -range;
    }

    if (reversedXDifference >= 0 && reversedXDifference <= range) {
        xFinal = draggedDistance;
    }

    return xFinal;
}
